import { render, staticRenderFns } from "./curriculumVideo.vue?vue&type=template&id=4d005a30&scoped=true&"
import script from "./curriculumVideo.vue?vue&type=script&lang=js&"
export * from "./curriculumVideo.vue?vue&type=script&lang=js&"
import style0 from "./curriculumVideo.vue?vue&type=style&index=0&id=4d005a30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d005a30",
  null
  
)

export default component.exports